/* Conmutador de colecciones · extras 144 · Peak | E-Commerce Lab · v1.1
   Mueve la pastilla seleccionada al inicio con animación (escritorio y móvil por separado). */
(function () {
  if (window.__csExtras144) return;
  window.__csExtras144 = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mode(root) {
    return (mq.matches ? root.dataset.frontM : root.dataset.frontD) || 'none';
  }

  function apply(root, animate) {
    var bar = root.querySelector('[data-cs-tabs]');
    if (!bar) return;
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('[role="tab"]'));
    var m = mode(root);
    var first = m === 'first';
    var before = animate && !reduce.matches ? tabs.map(function (t) { return t.getBoundingClientRect(); }) : null;

    tabs.forEach(function (t) {
      t.style.order = first && t.getAttribute('aria-selected') === 'true' ? '-1' : '';
    });

    if (before && first && tabs[0] && tabs[0].animate) {
      tabs.forEach(function (t, i) {
        var a = before[i], b = t.getBoundingClientRect();
        var dx = a.left - b.left, dy = a.top - b.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
        t.animate([{ translate: dx + 'px ' + dy + 'px' }, { translate: '0px 0px' }], { duration: 420, easing: 'cubic-bezier(.3,.7,.2,1)' });
      });
    }

    if (first && bar.scrollWidth > bar.clientWidth + 2) {
      bar.scrollTo({ left: 0, behavior: animate && !reduce.matches ? 'smooth' : 'auto' });
    }
    var sel = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
    if (sel) {
      root.querySelectorAll('[data-vl-for]').forEach(function (el) {
        el.hidden = el.getAttribute('data-vl-for') !== sel.getAttribute('data-block-id');
      });
    }
    if (root._csLayout) root._csLayout();
  }

  function init(root) {
    if (!root || root.dataset.csExtras) return;
    root.dataset.csExtras = '1';
    var bar = root.querySelector('[data-cs-tabs]');
    if (!bar) return;
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      /* Espera a que el conmutador termine su propio desplazamiento. */
      setTimeout(function () { busy = false; apply(root, true); }, 30);
    }).observe(bar, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
    apply(root, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cs][data-front-d]').forEach(init);
  }

  var onBp = function () {
    document.querySelectorAll('[data-cs][data-front-d]').forEach(function (r) { apply(r, false); });
  };
  if (mq.addEventListener) mq.addEventListener('change', onBp); else if (mq.addListener) mq.addListener(onBp);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
